import { Input } from 'domain/Input';

export default function calculateGreaseQuantity(input: Input): number {
  return calculate(input.dimensions.outerDiameter ?? 260, input.replenishment.value, input.dimensions.width ?? 55);
}

export function calculate(outerDiameter: number, replenishment: number, width: number): number {
  return outerDiameter * replenishment * width;
}
